import store from "../../../store";
import bolt_export from './bolt_export.vue';

window.bolt_export =  new Vue({
    store,
    el: 'div#bolt_export',

    name : "bolt_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        bolt_export,
    }
});
